var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { ContainerFull, MultiQuoteHeading, } from "../../../components/Styles/Styles";
import Header from "../../../components/Header";
import Image from "../../../components/Image";
import { PHASE } from "../../../routeConfig";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { useHistory } from "react-router-dom";
function Row(props) {
    return React.createElement("div", __assign({}, props, { className: "mb-[30px] flex w-full px-6" }));
}
function IconWrapper(props) {
    return React.createElement("div", __assign({}, props, { className: "w-[40%] text-center" }));
}
function TextWrapper(props) {
    return React.createElement("div", __assign({}, props, { className: "w-[60%] capitalize" }));
}
var MAX_VEHCILES = 3;
var SHOW_DURATION = 3000;
export default function BasePoliciesLoadedRoute(_a) {
    var _b, _c, _d;
    var policy = _a.policy;
    var push = useHistory().push;
    var dispatch = useAppDispatch();
    var policyHolderAddress = (_b = policy.policyHolder) === null || _b === void 0 ? void 0 : _b.address;
    var address = "property" in policy
        ? (_d = (_c = policy.property) === null || _c === void 0 ? void 0 : _c.address) !== null && _d !== void 0 ? _d : policyHolderAddress
        : policyHolderAddress;
    var extraVehicles = "vehicles" in policy ? policy.vehicles.length - MAX_VEHCILES : 0;
    React.useEffect(function () {
        var timeoutId = setTimeout(function () {
            push(PHASE.VERIFY_CONTACT);
        }, SHOW_DURATION);
        return function () { return clearTimeout(timeoutId); };
    }, [push, dispatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(ContainerFull, { centerVertically: true },
            React.createElement("div", { className: "mx-auto mb-6 flex items-center justify-center" },
                React.createElement(Image, { src: "/assets/icons/green-checkmark.svg", width: 48, height: 48, alt: "" })),
            React.createElement(MultiQuoteHeading, { className: "mb-10" }, "Policy Loaded!"),
            "operators" in policy && policy.operators.length > 0 ? (React.createElement(Row, null,
                React.createElement(IconWrapper, null,
                    React.createElement(Image, { src: "/assets/icons/people-icon.svg", alt: "", width: "71", height: "45" })),
                React.createElement(TextWrapper, null, policy.operators.map(function (_a, index) {
                    var name = _a.name;
                    return (React.createElement("div", { key: index }, "".concat(name.firstName, " ").concat(name.lastName)));
                })))) : null,
            address ? (React.createElement(Row, null,
                React.createElement(IconWrapper, null,
                    React.createElement(Image, { src: "/assets/icons/home-icon.svg", alt: "", width: "60", height: "49" })),
                React.createElement(TextWrapper, null,
                    React.createElement("div", null,
                        address.number,
                        " ",
                        address.street,
                        " ",
                        address.type),
                    React.createElement("div", null,
                        address.city,
                        " ",
                        address.state,
                        " ",
                        address.zip)))) : null,
            "vehicles" in policy && policy.vehicles.length > 0 ? (React.createElement(Row, null,
                React.createElement(IconWrapper, null,
                    React.createElement(Image, { src: "/assets/icons/car-icon.svg", alt: "", width: "97", height: "31" })),
                React.createElement(TextWrapper, null,
                    policy.vehicles
                        .slice(0, MAX_VEHCILES)
                        .map(function (_a, index) {
                        var make = _a.make, model = _a.model, year = _a.year;
                        return (React.createElement("div", { key: index }, "".concat(year, " ").concat(make, " ").concat(model)));
                    }),
                    extraVehicles > 0 ? (React.createElement("div", null,
                        "...and ",
                        extraVehicles,
                        " more")) : null))) : null)));
}
